import React from 'react';

export enum BLACK_LIST_TYPE {
  CARD_MASK = 'cardMasks',
  CARD_PANS = 'cardPans',
  DEVICES = 'devices',
  EMAILS = 'emails',
  IP_ADDRESSES = 'ipAddresses',
}

export interface ITabComponent {
  children: (data: {
    content: React.ReactNode;
    createComponent?: React.ReactNode;
    deleteComponent?: React.ReactNode;
  }) => React.ReactElement;
}
